import { useTraderText } from '../context/TraderLanguageContext';

export const MobileAccountSummary = ({ currency, balance, credit, equity, freeMargin, usedMargin, openPL }) => {
  const tx = useTraderText();
  const money = value => Number(value ?? 0).toLocaleString(tx('en-US'), { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  const rows = [
    ['balance', 'Balance', balance], ['credit', 'Credit', credit], ['equity', 'Equity', equity],
    ['free-margin', 'Free Margin', freeMargin], ['used-margin', 'Used Margin', usedMargin], ['open-pl', 'Open P/L', openPL],
  ];
  return <section className="mt5-mobile-account-summary" data-testid="mobile-account-summary">
    <div className="mt5-account-currency" data-testid="mobile-summary-currency">{currency}</div>
    <dl>{rows.map(([id, label, value]) => <div key={id}>
      <dt>{tx(label)}</dt><dd data-testid={`mobile-positions-${id}`} className={id === 'open-pl' ? (value < 0 ? 'text-red-500' : 'text-green-500') : ''}>{money(value)}</dd>
    </div>)}</dl>
  </section>;
};